import React, { Fragment, useState, useEffect } from "react";
import GLSLCanvas from "../components/GLSLCanvas";
import end_frag from "../fragments/end-frag";

const Finished = ({ bridgeMint, carerMint }) => {
  const [uniforms] = useState({});
  const [frag, setFrag] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setFrag(end_frag);
    setIsLoading(false);
  }, []);

  return (
    <Fragment>
      {!isLoading && <GLSLCanvas
            class="canvasContainerFull"
            canvasClass="canvasFull"
            frag={frag}
            setUniforms={uniforms}/>}
      <div className="panelBlack">
        <p className="endText">Thank you</p>
        {bridgeMint ? <p className="endText">It takes some time for the bridge to transport Lifeforms</p> : null}
        {carerMint ? <p className="endLine">Your Memoryform should be viewable on <a href={process.env.REACT_APP_MEMORYFORMS_OPENSEA}>Opensea</a> very soon.</p> : null}
      </div>
    </Fragment>
  );
};

export default Finished;
